export const updateName = (oldName = '未命名') => {
  const nameParts = oldName.split('.');
  let newName: string;

  if (nameParts.length > 1) {
    const extension = nameParts.pop()!;
    const baseName = nameParts.join('.');
    newName = `${baseName}_1.${extension}`;
  } else {
    newName = `${oldName}_1`;
  }

  return newName;
};
